// extracted by mini-css-extract-plugin
export default {"mainBox":"DetailList_mainBox__s-ybH","headerTitle":"DetailList_headerTitle__AYY71","classCard":"DetailList_classCard__3BlgT","classinput_box":"DetailList_classinput_box__lnNyk"};